/**
 * Stato di una connessione SignalR (hub real-time), usato dalla nuvoletta in header.
 * I valori numerici sono mantenuti retro-compatibili con il template legacy
 * (1 = verde, 0 = rosso, -1 = arancione).
 */
export enum HubState {
  /** Connessione attiva — verde. */
  Online = 1,
  /** Connessione caduta / non raggiungibile — rosso. */
  Offline = 0,
  /** Connessione in corso o in riconnessione — arancione. */
  Connecting = -1,
}
